export const filterForUploadReconSchema = [
    {
        id: "fileSetCode",
        label: "Source",
        type: "text",
        multiselector: true,
        displayLogo: false,
        showTitleType: false,
        filterTitle: true,
        uniqueType: false,
        items: ['data from API'],
    },
    {
        id: "status",
        label: "Status",
        type: "text",
        multiselector: true,
        displayLogo: false,
        showTitleType: false,
        filterTitle: true,
        uniqueType: false,
        items: ['data from API'],
        // items: [
        //     { title: "Uploading", value: "UPLOADING" },
        //     { title: "Upload Failed", value: "UPLOADING_FAILED" },
        //     { title: "Uploaded", value: "UPLOADED" },
        //     { title: "Transforming", value: "TRANSFORMING" },
        //     { title: "Transforming Failed", value: "TRANSFORMING_FAILED" },
        //     { title: "Transformed", value: "TRANSFORMED" },
        //     { title: "Processing", value: "PROCESSING" },
        //     { title: "Processing Failed", value: "PROCESSING_FAILED" },
        //     { title: "Processed", value: "PROCESSED" },
        //     { title: "Reverting", value: "REVERTING" },
        //     { title: "Reverting Failed", value: "REVERTING_FAILED" },
        //     { title: "Reverted", value: "REVERTED" },
        // ],
    },
];
